<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12" md="12">
  <!-- <v-form id="payment-form">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <label for="email">
            Email Address
          </label>
          <input
            id="email"
            name="email"
            type="email"
            placeholder="jenny.rosen@example.com"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <label>Card</label>
          <div
            id="card-element"
            :class="cardFocused ? 'focused' : ''"
            @focus="cardFocused = 'true'"
            @blur="cardFocused = 'false'"
          ></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-btn @click="submitPayment">Click to submit</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form> -->
  <div>
    <form v-if="!orderIsComplete">
      <div class="sr-payment-form payment-view">
        <div class="sr-form-row">
          <label for="card-element">
            Payment details
          </label>
          <div class="sr-combo-inputs">
            <div class="sr-combo-inputs-row">
              <input
                id="email"
                type="text"
                placeholder="Email"
                autocomplete="cardholder"
                class="sr-input"
              />
            </div>
            <div class="sr-combo-inputs-row">
              <div
                id="card-element"
                class="sr-input sr-card-element"
                :class="cardFocused"
              ></div>
            </div>
          </div>
          <div
            v-if="errorMessage"
            id="card-errors"
            class="sr-field-error"
            role="alert"
          ></div>
        </div>
        <v-btn id="submit" :disabled="buttonDisabled" @click="submitPayment">
          <div id="spinner" class="hidden" :class="spinner"></div>
          <span id="button-text" :class="buttonTextHidden">Subscribe</span>
        </v-btn>
        <div class="sr-legal-text">
          Your card will be immediately charged
          <span class="order-total">$14.00</span>.
        </div>
      </div>
    </form>
    <div v-else>
      <div class="sr-payment-summary hidden completed-view">
        <h1>Your subscription is <span class="order-status">{{ subscriptionStatus }}</span></h1>
        <h4>
          <a>View subscription response:</a>
        </h4>
      </div>
      <div class="sr-section hidden completed-view">
        <div class="sr-callout">
          <pre><code>{{ subscriptionCode }}</code></pre>
        </div>
        <button onclick="window.location.href='/'">Restart demo</button>
      </div>
    </div>
  </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'StripePayment',
  data() {
    return {
      stripeAPIToken: 'pk_test_Ex4ZqT4BRnOyJimuVax044sk00iVC52QuR',
      stripe: '',
      elements: '',
      card: '',
      cardFocused: false,
      errorMessage: '',
      subscriptionStatus: '',
      subscriptionCode: '',
      orderIsComplete: false,
      buttonDisabled: false
    }
  },
  mounted() {
    this.includeStripe(
      'js.stripe.com/v3/',
      // eslint-disable-next-line func-names
      function() {
        this.configureStripe()
      }.bind(this)
    )
  },
  methods: {
    /*
        Includes Stripe.js dynamically
    */
    includeStripe(URL, callback) {
      const documentTag = document
      const tag = 'script'
      const object = documentTag.createElement(tag)
      const scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = `https://${URL}`
      if (callback) {
        object.addEventListener(
          'load',
          // eslint-disable-next-line func-names
          function(e) {
            callback(null, e)
          },
          false
        )
      }
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    /*
    Configures Stripe by setting up the elements and 
    creating the card element.
    */
    configureStripe() {
      // eslint-disable-next-line
      this.stripe = Stripe(this.stripeAPIToken)

      this.elements = this.stripe.elements()
      this.card = this.elements.create('card')

      this.card.mount('#card-element')
    },
    submitPayment() {
      this.changeLoadingState(true);
      this.createPaymentMethodAndCustomer(this.stripe, this.card)
    },
    showCardError(error) {
      this.changeLoadingState(false)
      this.errorMessage = error.message
      // setTimeout(function() {
      //   this.errorMessage = ''
      // }, 8000);
    },
    createPaymentMethodAndCustomer(stripe, card) {
      const cardholderEmail = document.querySelector('#email').value
      stripe
        .createPaymentMethod('card', card, {
          billing_details: {
            email: cardholderEmail
          }
        })
        .then(result => {
          if (result.error) {
            this.showCardError(result.error)
          } else {
            this.createCustomer(result.paymentMethod.id, cardholderEmail)
          }
        })
    },
    async createCustomer(paymentMethod, cardholderEmail) {
      const customer = await this.stripe.customers.create({
        payment_method: paymentMethod,
        email: cardholderEmail,
        invoice_settings: {
          default_payment_method: paymentMethod
        }
      })
      const subscription = await this.stripe.subscriptions.create({
        customer: customer.id,
        items: [{ plan: 'plan_H34q6lqzsv4OJh' }],
        expand: ['latest_invoice.payment_intent']
      })
      this.handleSubscription(subscription)
    },
    handleSubscription(subscription) {
      const { latestInvoice } = subscription
      const { paymentIntent } = latestInvoice

      if (paymentIntent) {
        const { clientSecret, status } = paymentIntent;

        if (status === 'requires_action') {
          this.stripe.confirmCardPayment(clientSecret).then(result => {
            if (result.error) {
              // Display error message in your UI.
              // The card was declined (i.e. insufficient funds, card has expired, etc)
              this.changeLoadingState(false)
              this.showCardError(result.error)
            } else {
              // Show a success message to your customer
              this.confirmSubscription(subscription.id)
            }
          })
        } else {
          // No additional information was needed
          // Show a success message to your customer
          this.orderComplete(subscription)
        }
      } else {
        this.orderComplete(subscription)
      }
    },
    async confirmSubscription(subscriptionId) {
      const subscription = await this.stripe.subscriptions.retrieve(
        subscriptionId
      )
      this.orderComplete(subscription)
    },
    getPublicKey() {
      return 'pk_test_Ex4ZqT4BRnOyJimuVax044sk00iVC52QuR'
    },
    orderComplete(subscription) {
      this.changeLoadingState(false)
      const subscriptionJson = JSON.stringify(subscription, null, 2)
      this.orderIsComplete = true
      this.subscriptionStatus = subscription.status
      this.subscriptionCode = subscriptionJson
      this.updateLocalDB(subscription.status, subscriptionJson)
    },
    updateLocalDB(status, subId) {
      console.log('Update the user with the following:')
      console.log('Subscription Status: ', status)
      console.log('Subscription Id: ', subId)
    },
    changeLoadingState(isLoading) {
      if (isLoading) {
        this.spinner = 'loading'
        this.buttonDisabled = true
        this.buttonTextHidden = 'hidden'
        document.querySelector('#spinner').classList.add('loading')
        document.querySelector('button').disabled = true

        document.querySelector('#button-text').classList.add('hidden')
      } else {
        document.querySelector('button').disabled = false
        document.querySelector('#spinner').classList.remove('loading')
        document.querySelector('#button-text').classList.remove('hidden')
        this.spinner = ''
        this.buttonDisabled = false
        this.buttonTextHidden = ''
      }
    }
    // submitPayment() {
    //   // eslint-disable-next-line
    //   this.stripe.createToken(this.card).then(function(result) {
    //     if (result.error) {
    //       // Inform the user if there was an error.
    //       const errorElement = document.getElementById('card-errors')
    //       errorElement.textContent = result.error.message
    //     } else {
    //       // Send the token to your server.
    //       console.log('result.token is: ', result.token)
    //     }
    //   })
    // }
  }
}
</script>
<style scoped>
.paymentForm {
  border: 1px solid red;
}
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
.sr-root {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 980px;
  padding: 48px;
  align-content: center;
  justify-content: center;
  height: auto;
  min-height: 100vh;
  margin: 0 auto;
}
.sr-header {
  margin-bottom: 32px;
}
.sr-payment-summary {
  margin-top: 20px;
  margin-bottom: 20px;
}
.sr-main,
.sr-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  align-self: center;
}
.sr-main {
  width: var(--form-width);
}
.sr-content {
  padding-left: 48px;
}
.sr-header__logo {
  background-image: var(--logo-image);
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
}
.sr-legal-text {
  color: var(--gray-light);
  text-align: center;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}
.sr-field-error {
  color: var(--accent-color);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

/* Form */
.sr-form-row {
  margin: 16px 0;
}
label {
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 8px;
  display: inline-block;
}

/* Inputs */
.sr-input,
.sr-select,
input[type='text'] {
  border: 1px solid var(--gray-border);
  border-radius: var(--radius);
  padding: 5px 12px;
  height: 44px;
  width: 100%;
  transition: box-shadow 0.2s ease;
  background: white;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.sr-input:focus,
input[type='text']:focus,
button:focus,
.focused {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
  z-index: 9;
}
.sr-input::placeholder,
input[type='text']::placeholder {
  color: var(--gray-light);
}

/* Checkbox */
.sr-checkbox-label {
  position: relative;
  cursor: pointer;
}

.sr-checkbox-label input {
  opacity: 0;
  margin-right: 6px;
}

.sr-checkbox-label .sr-checkbox-check {
  position: absolute;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
  border: 1px solid var(--gray-border);
  border-radius: 4px;
  transition: all 0.2s ease;
}

.sr-checkbox-label input:focus ~ .sr-checkbox-check {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
}

.sr-checkbox-label input:checked ~ .sr-checkbox-check {
  background-color: var(--accent-color);
  background-image: url('https://storage.googleapis.com/stripe-sample-images/icon-checkmark.svg');
  background-repeat: no-repeat;
  background-size: 16px;
  background-position: -1px -1px;
}

/* Select */
.sr-select {
  display: block;
  height: 44px;
  margin: 0;
  background-image: url('https://storage.googleapis.com/stripe-sample-images/icon-chevron-down.svg');
  background-repeat: no-repeat, repeat;
  background-position: right 12px top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.sr-select:after {
}
.sr-select::-ms-expand {
  display: none;
}
.sr-select:hover {
  cursor: pointer;
}
.sr-select:focus {
  box-shadow: 0 0 0 1px rgba(50, 151, 211, 0.3), 0 1px 1px 0 rgba(0, 0, 0, 0.07),
    0 0 0 4px rgba(50, 151, 211, 0.3);
  outline: none;
}
.sr-select option {
  font-weight: 400;
}
.sr-select:invalid {
  color: var(--gray-light);
  background-opacity: 0.4;
}

/* Combo inputs */
.sr-combo-inputs {
  display: flex;
  flex-direction: column;
}
.sr-combo-inputs input,
.sr-combo-inputs .sr-select {
  border-radius: 0;
  border-bottom: 0;
}
.sr-combo-inputs > input:first-child,
.sr-combo-inputs > .sr-select:first-child {
  border-radius: var(--radius) var(--radius) 0 0;
}
.sr-combo-inputs > input:last-child,
.sr-combo-inputs > .sr-select:last-child {
  border-radius: 0 0 var(--radius) var(--radius);
  border-bottom: 1px solid var(--gray-border);
}
.sr-combo-inputs > .sr-combo-inputs-row:first-child input:first-child {
  border-radius: var(--radius) 0 0 0;
}
.sr-combo-inputs > .sr-combo-inputs-row:first-child input:last-child {
  border-radius: 0 var(--radius) 0 0;
}
.sr-combo-inputs-row {
  width: 100%;
  display: flex;
}

.sr-combo-inputs-row > input {
  width: 100%;
  border-radius: 0;
}

.sr-combo-inputs > .sr-combo-inputs-row:first-child input:last-child {
  border-radius: var(--radius) var(--radius) 0 0;
}

.sr-combo-inputs-row:not(:first-of-type) .sr-input {
  border-radius: 0 0 var(--radius) var(--radius);
}

/* Buttons and links */
button {
  background: var(--accent-color);
  border-radius: var(--radius);
  color: white;
  border: 0;
  padding: 12px 16px;
  margin-top: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: block;
}
button:hover {
  filter: contrast(115%);
}
button:active {
  transform: translateY(0px) scale(0.98);
  filter: brightness(0.9);
}
button:disabled {
  opacity: 0.5;
  cursor: none;
}

.sr-payment-form button,
.fullwidth {
  width: 100%;
}

a {
  color: var(--accent-color);
  text-decoration: none;
  transition: all 0.2s ease;
}

a:hover {
  filter: brightness(0.8);
}

a:active {
  filter: brightness(0.5);
}

/* Code block */
.sr-callout {
  background: var(--gray-offset);
  padding: 12px;
  border-radius: var(--radius);
  max-height: 400px;
  max-width: 600px;
  overflow: auto;
}
code,
pre {
  font-family: 'SF Mono', 'IBM Plex Mono', 'Menlo', monospace;
  font-size: 14px;
  overflow-x: auto;
  white-space: pre-wrap;
}

/* Stripe Element placeholder */
.sr-card-element {
  padding-top: 12px;
}

/* Responsiveness */
@media (max-width: 720px) {
  .sr-root {
    flex-direction: column;
    justify-content: flex-start;
    padding: 48px 20px;
    min-width: 320px;
  }

  .sr-header__logo {
    background-position: center;
  }

  .sr-payment-summary {
    text-align: center;
  }

  .sr-content {
    display: none;
  }

  .sr-main {
    width: 100%;
  }
}

/* Pasha styles – Brand-overrides, can split these out */
:root {
  --accent-color: #ed5f74;
  --headline-color: var(--accent-color);
  --logo-image: url('https://storage.googleapis.com/stripe-sample-images/logo-pasha.svg');
}

.pasha-image-stack {
  display: grid;
  grid-gap: 12px;
  grid-template-columns: auto auto;
}

.pasha-image-stack img {
  border-radius: var(--radius);
  background-color: var(--gray-border);
  box-shadow: 0 7px 14px 0 rgba(50, 50, 93, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.07);
  transition: all 0.8s ease;
  opacity: 0;
}

.pasha-image-stack img:nth-child(1) {
  transform: translate(12px, -12px);
  opacity: 1;
}
.pasha-image-stack img:nth-child(2) {
  transform: translate(-24px, 16px);
  opacity: 1;
}
.pasha-image-stack img:nth-child(3) {
  transform: translate(68px, -100px);
  opacity: 1;
}

/* todo: spinner/processing state, errors, animations */

/* Animated form */

.sr-root {
  animation: 0.4s form-in;
  animation-fill-mode: both;
  animation-timing-function: ease;
}

.sr-payment-form .sr-form-row {
  animation: 0.4s field-in;
  animation-fill-mode: both;
  animation-timing-function: ease;
  transform-origin: 50% 0%;
}

/* need saas for loop :D  */
.sr-payment-form .sr-form-row:nth-child(1) {
  animation-delay: 0;
}
.sr-payment-form .sr-form-row:nth-child(2) {
  animation-delay: 60ms;
}
.sr-payment-form .sr-form-row:nth-child(3) {
  animation-delay: 120ms;
}
.sr-payment-form .sr-form-row:nth-child(4) {
  animation-delay: 180ms;
}
.sr-payment-form .sr-form-row:nth-child(5) {
  animation-delay: 240ms;
}
.sr-payment-form .sr-form-row:nth-child(6) {
  animation-delay: 300ms;
}

.hidden {
  display: none;
}

.loading {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
  }
}

.sr-plans {
  display: flex;
  width: 600px;
}

.sr-plan {
  border: 1px solid rgb(232, 232, 232);
  border-radius: 6px;
  margin-right: 25px;
  height: 226px;
  width: 257px;
}

.sr-plan-inner {
  margin: 28px;
}

.sr-plan-name {
  color: rgb(166, 166, 166);
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0px;
}

.sr-plan-text {
  color: rgb(153, 153, 153);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 14px;
}

.sr-plan-button {
  border: 2px solid rgb(237, 95, 116);
  border-radius: 7px;
}

@keyframes field-in {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0px) scale(1);
  }
}

@keyframes form-in {
  0% {
    opacity: 0;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
